export const Tag = {
  Container: "CONTAINER",
  Instance: "INSTANCE",
  Text: "TEXT",
} as const;

// Container should render as <>{...}</>
export const CONTAINER_TYPE = "";
